import {axios} from "@/plugins/http-axios";
import {Module} from "vuex";
import {RootState} from "@/store/index";
import { IOfficesOfRegion } from "@/interfaces/office";
export interface ISysParameter{
    code: string;
    desc: string;
    value: string;
    resulttype: string;
}
export interface IStatusBank{
    "name": string; //"Аннулировано банком BANK_ANNUL",
    "count": number; //1515,
    "id": number; //11
}
interface ICommonBank{
    "id": number; //1,
    "name": string; //"АО \"Банк\"",
    "inn": string; //"7709345294",
    "kpp": string; //"770901001",
}
export interface IBaseOffice {
    "id": number;
    "name": string;
    "city": string;
    "shortaddress": string;
    "fulladdress": string;
}
export interface IBaseOffice2 extends IBaseOffice{
    "cftcode": string;
    "cftcalendar": string;
    "bik": string;
    "korr": string;
    "korrlocation": string;
    "branchcode": string;
    "code": string;
    "sortedItem": number;
    "bankid": number;
    "hide": boolean;
}
export interface IBankOffice extends IBaseOffice2{
    "regionid": number;

}
interface IBank2 extends ICommonBank{
    "okpo": string;
    "ogrn": string;
    regions: IBankRegion[];
}
export interface IBankRegion {
    id:number;
    name:string;
    hide:boolean;
    orderPosition:number;
    offices: IBankOffice[];
}
export interface IRegion {
    hide: boolean
    id: number
    name: string
    orderPosition: number
}
interface ISysSetting{
    "code": string; //"ENABLE_LKK_AGENT",
    "desc": string; //"Включить ЛКК для агентов",
    "value": boolean; //false,
    "affectedSystems": string[];//["Личный кабинет Банка", "Личный кабинет Клиента"]
}

interface IBankState{
    statuses: IStatusBank[],
    // offices: any[],
    officesList: IBankOffice[],
    // officesListNotHide: any[],
    sysParameters: ISysParameter[],
    sysSettings: ISysSetting[],
    bankingRegions: IOfficesOfRegion[],
}

export default <Module<IBankState, RootState>>{
    state: {
        statuses: [],
        // offices: [],
        officesList: [],
        // officesListNotHide: [],
        sysParameters: [],
        sysSettings: [],
        bankingRegions:[],
    },
    mutations: {
        setSysSettings(state, data:ISysSetting[]){
            state.sysSettings = data;
        },
        setSysSettingsValue(state, {code='', value=false}={}) {
            const sysPar = state.sysSettings.find(par => par.code == code);
            if (sysPar)
                sysPar.value = value;
        },
        setSysParameters(state, data:ISysParameter[]) {
            state.sysParameters = data;
        },
        setStatuses(state, statuses:IStatusBank[]) {
            state.statuses = statuses;
        },
        setOffices(state, offices:IBankOffice[]) {
            state.officesList = offices;
        },
        //todo Дублирование кода в лкк и лкб
        _setBankingRegions(state, regions:IBankRegion[]) {
            regions.sort((a, b)=>{ return a.orderPosition - b.orderPosition; });
            const bankingR = regions.filter(word => word.hide === false);
            state.bankingRegions = bankingR.map<IOfficesOfRegion>(region=>{
                region.offices.sort((a, b)=>{ return a.sortedItem - b.sortedItem; });
                return {text: region.name, value:region.offices};
            });
        },
    },
    actions: {
        //todo Повторяющийся запрос в env
        async getSysParameters({state, commit, dispatch, rootGetters}):Promise<ISysParameter[]> {
            if (state.sysParameters.length)
                return Promise.resolve(state.sysParameters);
            return axios.get<ISysParameter[]>(rootGetters.uri.sysParameters)
                .then(resp => {
                    commit('setSysParameters', resp.data);
                    return resp.data;
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },

        //список всех офисов без исключения,
        async getOffices({getters, commit, dispatch, rootGetters}):Promise<IBankOffice[]> {
            if (getters.officesList.length)
                return Promise.resolve(getters.officesList);
            return axios.get<IBankOffice[]>(rootGetters.uri.office)
                .then((resp) => {
                    commit('setOffices', resp.data);
                    return Promise.resolve(getters.officesList);
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
        //Список регионов с офисами, для анкеты
        async getBankingRegions({commit, dispatch, rootGetters, getters}):Promise<IOfficesOfRegion[]>{
            return axios.get<IBank2[]>(rootGetters.uri.bankOffices)
                .then(resp => {
                    commit('_setBankingRegions', resp.data[0].regions);
                    return getters.bankingRegions;
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
        //todo Повторяющийся запрос в env
        async getSystemSetting({state, commit, dispatch, rootGetters}):Promise<void> {
            if (state.sysSettings.length)
                return Promise.resolve();
            return axios.get<ISysSetting[]>(rootGetters.uri.mainsysset)
                .then(resp => {
                    commit('setSysSettings', resp.data);
                    return;
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
        async getRequestStatusCount({commit, dispatch, rootGetters}) {
            try {
                const response = await axios.get<IStatusBank[]>(rootGetters.uri.storageRequestsStatusCount);
                commit('setStatuses', response.data);
                return response;
            } catch (error) {
                dispatch('setError', error);
                return Promise.reject(error);
            }
        },
    },
    getters: {
        bankingRegions: (state):IOfficesOfRegion[] => state.bankingRegions,
        statusesList: (state):IStatusBank[] => state.statuses,
        officesList: (state):IBankOffice[] => state.officesList,
        sysParameters: (state):ISysParameter[] => state.sysParameters,
        sysSettings: (state):ISysSetting[] => state.sysSettings
    },
};
